import React, {Component} from 'react';
import {connect} from 'react-redux';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import {List, Header, Segment, Button} from 'semantic-ui-react';
import _ from 'lodash';

export class DynamicSubSectionNav extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    const {
      navToSpecificLocation,
      itemToDisplay,
      config,
      title,
      showContinue,
      subHeader,
    } = this.props;

    const {contents} = config;
    const matchedSectionIndex = _.findIndex(contents, {title: itemToDisplay});
    const targetSection =
      matchedSectionIndex === -1 ? -1 : contents[matchedSectionIndex].contents;

    return (
      <Segment padded className="narrow">
        {title && (
          <Header as="h1">
            {title}
            <br />
            {subHeader && !subHeader.isHidden && (
              <Header as={subHeader.size || 'h1'}>
                {subHeader.title}
                <Header.Subheader>{subHeader.guidance}</Header.Subheader>
              </Header>
            )}
          </Header>
        )}
        {_.map(targetSection, (subSections, index) => (
          <List>
            {' '}
            {/* ::: If you want to add indent include this class => className="indent"*/}
            <List.Item>
              <div id="DynamicSubSectionNav">
                <a
                  className="iconLanding"
                  onClick={() =>
                    navToSpecificLocation(
                      `contents[${matchedSectionIndex}].contents[${index}]`
                    )
                  }
                  href={`#${subSections.title}`}
                >
                  {subSections.title}
                </a>
              </div>
            </List.Item>
          </List>
        ))}
        <br />
        {showContinue && (
          <Button
            onClick={() =>
              navToSpecificLocation(`contents[${matchedSectionIndex}].contents[${0}]`)
            }
            primary
          >
            Continue
          </Button>
        )}
      </Segment>
    );
  }
}

export const mapStateToProps = (state) => {
  const {data, config, context, currentLocation} = state.dynamicComponent;
  const location = currentLocation === '' ? 'contents[0]' : currentLocation;
  return {
    jwt: state.auth.token,
    subApplication: data,
    config: config,
    context: context,
    currentLocation: location,
  };
};

export default connect(mapStateToProps, null)(connectDynamic(DynamicSubSectionNav));
